import Grid from 'components/core/Grid';
import StripeCardError from './components/StripeCardError';
import { StripeCardholderName } from './components/StripeCardholderName';
import styled from 'styled-components';
import { CardElement } from '@stripe/react-stripe-js';
import { UseStripeField } from 'components/core/stripe/StripeField/hooks/useStripeField';

const StyledCardElement = styled(CardElement)`
  border: 1px solid ${props => props.theme.palette.grey[400]};
  padding: ${props => props.theme.spacing(1.5)} ${props => props.theme.spacing(1.5)};
  border-radius: 3px;
  background-color: #fff; 
`;

interface StripeFieldProps {
  hidePostalCode?: boolean;
}

type Props = StripeFieldProps &
  Pick<
    UseStripeField,
    | 'onChangeCard'
    | 'onChangeCardholderName'
    | 'alluraServerApiError'
    | 'cardError'
    | 'stripeApiError'
    | 'hasCardholderNameError'
    | 'cardholderName'
  >;

/** Pass props in from useStripeField */
export const StripeField = ({
  hasCardholderNameError,
  cardError,
  stripeApiError,
  alluraServerApiError,
  cardholderName,
  hidePostalCode = true,
  onChangeCard,
  onChangeCardholderName,
}: Props) => {
  return (
    <>
      <Grid item xs={12}>
        <StripeCardholderName
          value={cardholderName}
          onChange={onChangeCardholderName}
          hasError={hasCardholderNameError}
        />
      </Grid>
      <Grid item xs={12}>
        <StyledCardElement options={{ hidePostalCode }} onChange={onChangeCard} />
        {cardError ? <StripeCardError errorMessage={cardError.message} /> : null}
        {alluraServerApiError ? <StripeCardError errorMessage={alluraServerApiError} /> : null}
        {stripeApiError ? <StripeCardError errorMessage={stripeApiError} /> : null}
      </Grid>
    </>
  );
};
